import ShareLinkCard from './ShareLinkCard'

export default ShareLinkCard
